import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ObservableMedia } from '@angular/flex-layout';
import { MdListComponent } from './md-list/md-list.component';
import { SiteModel } from '../../../models/site.model';
import { SiteMasterService } from '../../../services/site-master.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { AuthService } from 'src/app/services/auth.service';
import { Constants } from 'src/app/shared';
import {
  SiteService,
  UtilitiesService,
  CommonService,
  UserManagementService
} from 'src/app/services/index';
import { PlatformLocation } from '@angular/common';
/*
  The material-table requires a DataSource.
  Wrapping UserService does the job.
 */
class TableDataSource implements DataSource<SiteModel> {
  constructor(private siteService: SiteMasterService) {}

  connect(): Observable<SiteModel[]> {
    this.loadSites();
    return this.siteService.items;
  }

  disconnect() {}

  loadSites(params?: Params) {
    this.siteService.queryAll(params);
  }
}

@Component({
  selector: 'app-site-master',
  templateUrl: './site-master.component.html',
  styleUrls: ['./site-master.component.scss']
})
export class SiteMasterComponent
  extends MdListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  displayedColumns = [
    'siteId',
    'siteName',
    'industryType',
    'city',
    'contactPersonName',
    'executionState',
    'status',
    'clickHere'
  ];

  dataSource: TableDataSource;
  useSlideoverSidebarMode = false;
  sampleData = [];
  hasPermission = false;
  VIEW_PER = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private router: Router,
    route: ActivatedRoute,
    public siteMasterService: SiteMasterService,
    private siteService: SiteService,
    private utilitiesService: UtilitiesService,
    private authService: AuthService,
    private location: PlatformLocation,
    private commonService: CommonService,
    private observableMedia: ObservableMedia
  ) {
    super(siteMasterService, route);

    // customize responsive behavior of sidebar / slideover switch
    this.observableMedia
      .asObservable()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((_) => {
        this.useSlideoverSidebarMode = this.observableMedia.isActive('lt-md');
      });

    location.onPopState(() => {
      this.commonService.showDialogMessage(
        'Dear User, Please use UI menu options to navigate'
      );

      history.pushState(null, null, window.location.pathname);
    });
  }

  ngOnInit() {
    this.hasPermission = this.authService.doAuthorization([
      Constants.ACTIVITY.NEW_SITE,
      Constants.ACTIVITY.EDIT_SITE,
      Constants.ACTIVITY.DELETE_SITE
    ]);
    this.VIEW_PER = this.authService.doAuthorization([
      Constants.ACTIVITY.VIEW_SITE
    ]);

    this.siteService.getSiteDetails().subscribe((data) => {
      if (data.length > 0) {
        if (data.length === 1) {
          this.router.navigate(['site', 'over-view'], {
            queryParams: { siteId: data[0].siteId }
          });
        }
        let model: SiteModel;
        this.sampleData = data.map((item) => {
          model = new SiteModel();
          Object.assign(model, item);
          return model;
        });
        this.siteMasterService.setData(this.sampleData);
        this.siteMasterService.pageSize = 10;
        this.dataSource = new TableDataSource(this.siteMasterService);
        this.dataSource.connect();

        super.ngOnInit();
      }
    });
  }
  ngAfterViewInit() {
    this.utilitiesService.removePlantLogo();
  }
  ngOnDestroy() {
    // reset pageSize because same service instance is used in other examples
    this.siteMasterService.pageSize = 500;
    super.ngOnDestroy();
  }
  goToSiteSetUp(event: Event, siteId: string) {
    this.router.navigate(['/setup-project'], {
      queryParams: { siteId: siteId }
    });
    event.preventDefault();
    event.stopPropagation();
  }
  goToSite(event: Event, siteId: string, siteName: string) {
    this.router.navigate(['/site'], {
      queryParams: { siteId: siteId, siteName: siteName }
    });
    event.preventDefault();
    event.stopPropagation();
  }
  getSensorHealth(sensorHealth) {
    let result: any;
    if (sensorHealth === undefined || sensorHealth === null) {
      return 'ON_status';
    }
    // Received Map - Criticality, No Of Open alerts
    if (sensorHealth.VeryCritical > 0) {
      result = 'OFF_status';
    } else if (sensorHealth.Critical > 0) {
      result = 'NA_status';
    } else {
      result = 'ON_status';
    }
    return result;
  }
}
